import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic, Modal, Descriptions, Tabs, Popconfirm } from 'antd';
import CustomerService from "services/customer"
import DebtService from "services/debt"
import { formatCurrency } from "utils/number"
import { formatDate, formatOnlyDate } from "utils/date"
import { useNavigate } from 'react-router';
import UpdateDebt from 'components/debt/Update';
import AddDebt from "components/debt/AddDebt"
import AddPayment from "components/debt/AddPayment"
import _ from "lodash"
import { useApp } from 'contexts/app';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import Debt from "./Debt"
import CustomerInfoEdit from "components/customer/CustomerInfoEdit"
import CustomerLoginEdit from "components/customer/CustomerLoginEdit"
import StoreSettingService from "services/store_setting"
const service = new CustomerService();
const debtService = new DebtService();
const storeSettingService = new StoreSettingService();


const { Search } = Input;
const CustomerInfo = ({ id, open, onClose, onSave }) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [customer, setCustomer] = useState({});
    const [orders, setOrders] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showCustomerEdit, setShowCustomerEdit] = useState(false);
    const [showCustomerLoginEdit, setShowCustomerLoginEdit] = useState(false);
    const [isAccountLoginMode, setIsAccountLoginMode] = useState(false);



    const { printPdf, showLoading, downloadPDF } = useApp();

    useEffect(() => {
        if (isModalOpen != open)
            setIsModalOpen(open)
    }, [open])

    useEffect(() => {
        if (open) {
            loadLoginMethod();
        }
    }, [open])



    useEffect(() => {
        if (!isModalOpen && open && onClose) {
            onClose();
        }
        if (isModalOpen) {
            loadData();
        }

    }, [isModalOpen])

    // useEffect(() => {
    //     loadData({});
    // }, [phone])




    const loadData = async (data) => {
        setCustomer({});
        setOrders([])

        if (id) {

            var cus = await service.getByID(id);

            if (cus) {
                setCustomer(cus);
                var newOrder = _.orderBy(cus.orders, ['create_on'], ['desc']);
                setOrders(newOrder);


            }
        } else {
            setCustomer({});
            setOrders([])

        }

        // setData(lst);
    }

    const loadLoginMethod = async () => {
        try {
            var setting = await storeSettingService.getWebsiteSetting();
            setIsAccountLoginMode(setting?.login_method === "account");
        } catch (error) {
            setIsAccountLoginMode(false);
        }
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }






    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const onCustomerSave = async () => {
        await loadData();
        if (onSave) {
            onSave();
        }
    }




    const renderTabOrder = () => {
        const columns = [
            {
                title: 'Mã đơn hàng',
                render: (record) => {
                    return (
                        <Space direction='vertical'>
                            <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
                                {record.id}
                            </Button>
                            <div>
                                {formatDate(record.create_on)}
                            </div>
                        </Space>
                    )

                }
            },


            {
                title: 'Sản phẩm',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            <div>
                                {record.total_item}
                            </div>
                            <div>
                                {formatCurrency(record.total_amount)}
                            </div>
                        </Space>
                    )


                    return record.total_item
                }
            },
            {
                title: 'Trạng thái',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            {record.status == "canceled" &&
                                <div>
                                    Đã Huỷ
                                </div>
                            }

                            {record.status == "finalized" &&
                                <div>
                                    Đã Hoàn tất
                                </div>
                            }

                            {!["canceled", "finalized"].includes(record.status) &&
                                <>
                                    <div>
                                        Đang xử lý
                                    </div>

                                </>
                            }


                        </Space>
                    )


                    return record.total_item
                }
            },


        ];
        return (
            <Table dataSource={orders} columns={columns} scroll={{ y: 300 }} />
        )
    }





    const renderTabDebt = () => {

        return <Debt customer={customer} onChange={onCustomerSave}></Debt>

    }



    const items = [
        {
            key: 'order',
            label: 'Đơn hàng',
            children: renderTabOrder(),
        },
        {
            key: '2',
            label: 'Công nợ',
            children: renderTabDebt(),
        },

    ];







    return (
        <>

            <Modal
                title="Thông  tin khách hàng"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={"50%"}
                footer={
                    <Space>
                        <Button type='link' onClick={e => setShowCustomerEdit(true)}>Cập nhật thông tin</Button>
                        {isAccountLoginMode &&
                            <Button type='link' onClick={e => setShowCustomerLoginEdit(true)}>Quản lý đăng nhập</Button>
                        }
                        <Button onClick={handleCancel}>Close</Button>
                    </Space>
                }
            >
                <Space style={{ width: "100%" }} direction='vertical'>
                    <Descriptions column={1} >
                        <Descriptions.Item label="Họ và tên">{customer.full_name}</Descriptions.Item>

                        <Descriptions.Item label="SDT">{customer.phone}</Descriptions.Item>

                  
                        <Descriptions.Item label="Địa chỉ" span={3}>
                            {customer.address}
                        </Descriptions.Item>

                    </Descriptions>

                    <Row gutter={16}>
                        <Col flex="25%" >
                            <Statistic title="Đơn hàng" value={orders.length} />
                        </Col>
                        <Col flex="25%" >
                            <Statistic title="Số tiền" value={_.sumBy(orders, x => x.total_amount ?? 0)} precision={0} />
                        </Col>
                        <Col flex="25%" >
                            <Statistic title="Xu" value={customer.loyalty_point?.current ?? 0} precision={0} />

                        </Col>
                        {customer.debt?.current_debt != 0 &&
                            <Col flex="25%">
                                <Statistic title="Nợ" value={customer.debt?.current_debt ?? 0} precision={0} />
                            </Col>
                        }
                    </Row>
                    <Tabs items={items} />


                </Space>
            </Modal>
            <CustomerInfoEdit id={customer.id} open={showCustomerEdit} onSave={onCustomerSave} onClose={e => setShowCustomerEdit(false)}></CustomerInfoEdit>
            <CustomerLoginEdit id={customer.id} open={showCustomerLoginEdit} onSave={onCustomerSave} onClose={e => setShowCustomerLoginEdit(false)}></CustomerLoginEdit>
        </>

    )
}

export default CustomerInfo;
